import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterResults',
  standalone: true
})
export class FilterResultsPipe implements PipeTransform {
  transform(results: any[], chemicalId: string, departmentId: string, methodId: string): any[] {
    if (!results) return [];

    return results.filter(result => {
      let match = true;

      if (chemicalId && result.chemicalId !== chemicalId) {
        match = false;
      }

      if (departmentId && result.departmentId !== departmentId) {
        match = false;
      }

      if (methodId && result.methodId !== methodId) {
        match = false;
      }

      return match;
    });
  }
}
